 
<template>
  <!--  背景颜色可以动态修改 -->
  <div class="name"
       :style="{background:'white'}"
       style="border-bottom: 1px solid #F0F0F0;">
    <div class="colorBar"
         :style="{background:'white'}" />
    <!--  教室名称  -->
    <el-tooltip placement="top"
                effect="dark">
      <div slot="content">{{data.catalogName}}<br />{{data.name}}</div>
      <div style="width:100%;">
        <div style="width:45%;float:left;position: relative;overflow:hidden; white-space:nowrap; text-overflow:ellipsis;margin-right:5%">{{data.catalogName}}</div>
        <div style="width:48%;position: relative;overflow:hidden; white-space:nowrap; text-overflow:ellipsis;margin-left:55%;">{{data.name}}</div>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "TestLeft",
  props: {
    data: Object,
  },
};
</script>

<style  scoped>
.name {
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
  height: 100%;
  width: 100%;
  padding: 0 5px 0 0;
  border-radius: 8px 0 0 8px;
  align-items: center;
}
.colorBar {
  width: 10px;
  height: 100%;
}

.carId {
  flex: 1;
}

.type {
  padding: 0 5px 0 0;
  font-size: 1.2rem;
}
</style>
